var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProlificUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37564"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37567"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37566"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37565"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37564"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21781",
    d: "M4.041 1h20.918A3.041 3.041 0 0 1 28 4.041v20.918A3.041 3.041 0 0 1 24.959 28H4.041A3.041 3.041 0 0 1 1 24.959V4.041A3.041 3.041 0 0 1 4.041 1Z",
    fill: "none",
    stroke: "#3b5175",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21778",
    d: "M21.601 16.322v4.868c0 .6-.266.869-.863.869h-4.6c.181.181.32.326.465.47l.446.446a.726.726 0 0 1 0 1.032.71.71 0 0 1-1.013-.012c-.73-.718-1.454-1.436-2.178-2.166a.7.7 0 0 1 .018-1.032c.706-.712 1.418-1.417 2.123-2.123a.723.723 0 1 1 1.013 1.026c-.283.289-.573.567-.893.887h4.024v-4.2c-.018-.012-.03-.024-.048-.036-.271.284-.537.579-.826.844a1 1 0 0 1-.44.247.673.673 0 0 1-.754-.368.728.728 0 0 1 .121-.839c.078-.084.157-.163.235-.241.634-.633 1.261-1.267 1.894-1.906a.722.722 0 0 1 1.1-.006l2.075 2.075a.725.725 0 1 1-1.013 1.026c-.283-.258-.56-.535-.886-.861Z",
    fill: "#3b5175"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21779",
    d: "M11.975 22.334a5.148 5.148 0 0 0-7.566 0 .453.453 0 0 0-.117.3v1.8a.45.45 0 0 0 .45.444h6.9a.45.45 0 0 0 .45-.45v-1.8a.453.453 0 0 0-.117-.294Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21780",
    d: "M10.292 17.978a2.1 2.1 0 1 1-2.1-2.1 2.1 2.1 0 0 1 2.1 2.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "user-solid",
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21779",
    d: "M24.965 10.374a5.148 5.148 0 0 0-7.566 0 .453.453 0 0 0-.117.3v1.8a.45.45 0 0 0 .45.444h6.9a.45.45 0 0 0 .45-.45v-1.8a.453.453 0 0 0-.117-.294Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21780",
    d: "M23.282 6.018a2.1 2.1 0 1 1-2.1-2.1 2.1 2.1 0 0 1 2.1 2.1Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProlificUsers);
export default __webpack_public_path__ + "static/media/Prolific_Users.910d1932eb0bcf4d1a320e675caad2f4.svg";
export { ForwardRef as ReactComponent };